import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    seeWhatIsNext: 'See what’s next',
  },
  fr: {
    seeWhatIsNext: 'Voir les prochaines étapes',
  },
});

export default locales;
